import { fromJS } from "immutable";
import { sortDataByDate } from "./filter.js"
import * as actionTypes from './actionTypes'
import { balanceSummary } from './txnUitls';

const initialState = fromJS({
    filteredData: null,
    filterData: { data: '' },
    txnRadioValue: {},
    tabTransactionalData: {},
    activeTabKey: "1",
    otherTransactionDetails: {},
    otherTransactionDetailsLoading: true,
    txnExportData: {},
    txnPrintData: {},
    loadingPrintData: {
        AllTransactions:true,
        Contributions:true,
        Grants:true,
        OtherTransactions:true,
        Exchanges:true
    }
});

const transactionSummary = (state = initialState, action) => {
    switch (action.type) {

        case actionTypes.filterGridDataType:
            return state.setIn(['filteredData'], action.payload);

        case actionTypes.exportTxnDataType:
            return state
            .setIn(['txnExportData', action.payload.tab], action.payload);

        case actionTypes.fetchTransactionDataLoadingType:
            return state.setIn(["transactionalDetails", "isLoading"], true);

        case actionTypes.fetchTransactionDataSuccessType:
            if (action.payload.tabType === 'all') {
                return state
                    .setIn(["transactionalDetails", "data", "allData"], action.payload.data)
                    .setIn(["transactionalDetails", "isLoading"], false)
                    .setIn(["tabTransactionalData"], {})
                    .setIn(["tabTransactionalData", action.payload.tabType, "fetchedData"], true)

            } else {
                return state
                    .setIn(["transactionalDetails", "data", action.payload.tabType], action.payload.data[action.payload.tabType])
                    .setIn(["transactionalDetails", "isLoading"], false)
                    .setIn(["tabTransactionalData"], {})
                    .setIn(["tabTransactionalData", action.payload.tabType, "fetchedData"], true)

            }

        case actionTypes.fetchTransactionTabLoadingType:
            return state.setIn(["tabTransactionalData", action.payload, "loading"], true)

        case actionTypes.fetchTransactionTabSuccessType:
            if (action.payload.tabType === 'all') {
                return state
                    .setIn(["transactionalDetails", "data", "allData"], action.payload.data)
                    .setIn(["tabTransactionalData", action.payload.tabType, "fetchedData"], true)
                    .setIn(["tabTransactionalData", action.payload.tabType, "loading"], false);
            } else {
                return state
                    .setIn(["transactionalDetails", "data", action.payload.tabType], action.payload.data[action.payload.tabType])
                    .setIn(["tabTransactionalData", action.payload.tabType, "fetchedData"], true)
                    .setIn(["tabTransactionalData", action.payload.tabType, "loading"], false);
            }

        case actionTypes.fetchBalanceLoadingType:
            return state.setIn(["balanceDetails", "isLoading"], true);

        case actionTypes.fetchBalanceSuccessType:
            let balanceSummaryObj = balanceSummary(action.payload.balanceSummary);
            delete action.payload.balanceSummary;
            return state
                .setIn(["accountDetails", "data"], balanceSummaryObj)
                .setIn(["balanceDetails", "data"], action.payload)
                .setIn(["balanceDetails", "isLoading"], false);

        case actionTypes.fetchFeeLoadingType:
            return state.setIn(["feeAndExpenses", "isLoading"], true);

        case actionTypes.fetchFeeSuccessType:
            return state
                .setIn(["feeAndExpenses", "data"], action.payload)
                .setIn(["feeAndExpenses", "isLoading"], false);

        case actionTypes.fetchFeeContentLoadingType:
            return state.setIn(["feeContent", "isLoading"], true);

        case actionTypes.fetchFeeContentSuccessType:
            return state
                .setIn(["feeContent", "data"], action.payload)
                .setIn(["feeContent", "isLoading"], false);

        case actionTypes.filterSortType:
            const sortDataFilter = sortDataByDate(action.payload)
            return state
                .setIn(["filterData", "data"], sortDataFilter)

        case actionTypes.radioChangeType:
            return state.setIn(["txnRadioValue"], action.payload)

        case actionTypes.tabChangeType:
            return state.setIn(["activeTabKey"], action.payload)
        
            case actionTypes.filterDataPrintType:
                return state
                .setIn(['txnPrintData', action.payload.tab], action.payload)
                .setIn(["loadingPrintData", action.payload.tab], false)

        case actionTypes.fetchOtherTransactionSuccessType:
            return state
            .setIn(["otherTransactionDetails"], action.payload.data)
            .setIn(["otherTransactionDetailsLoading"], false)

        case actionTypes.fetchOtherTransactionLoadingType:
            return state
                .setIn(["otherTransactionDetails"], {})
                .setIn(["otherTransactionDetailsLoading"], true)                

        case actionTypes.clearOtherTransactionType:
            return state
                .setIn(["otherTransactionDetailsLoading"], true)

        default:
            return state;
    }
}

export default transactionSummary;